import { useFetch } from './fetch';
import { CustomerContractTypeSettingsResponse } from './types/customerContractTypeSettingsResponse';

export const useCustomerContractTypeSettings = (
  customerId: string,
  contractType: string,
) => {
  const { isLoading, serverError, apiData } = useFetch(
    'GET',
    `${process.env.REACT_APP_BACKEND_API_URL}/customercontracttypes/customernumber/${customerId}/contracttype/${contractType}`,
    {},
  );

  return {
    isLoading,
    CustomerContractTypeSettingsData:
      apiData as unknown as CustomerContractTypeSettingsResponse,
    serverError,
  };
};
